export class PostReservationState {
  id: number;
  content_en: string;
  content_fr: string;
  image: string;
  is_first: boolean;
  main_step_id: number;
  next_step_id: number;
  partner_id: number;
  timeline_en: string;
  timeline_fr: string;
  title_en: string;
  title_fr: string;
  type: string;
  order: number;
  childs?: PostReservationState[];
}
